import { navigation } from "../content";
import { CONTACT_EMAIL } from "../config";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer__grid">
        <div className="site-footer__brand">
          <Logo inverted />
          <p>
            Kratis gets hard-to-reach frontline evidence, turns it into a clear
            decision, and checks what happened next.
          </p>
          <span>
            Frontline evidence → Focused intelligence → Decision → Action →
            Verified result
          </span>
        </div>
        <div className="site-footer__links">
          <p className="footer-label">Explore</p>
          {navigation.map((item) => (
            <a key={item.label} href={item.href}>
              {item.label}
            </a>
          ))}
        </div>
        <div className="site-footer__links">
          <p className="footer-label">Company</p>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>
      </div>
      <div className="shell site-footer__bottom">
        <p>© {new Date().getFullYear()} Kratis. All rights reserved.</p>
        <p>Frontline intelligence for the physical economy</p>
      </div>
    </footer>
  );
}
